module.exports = require("core-js/library/fn/parse-int");